import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import SignatureCanvas from "react-signature-canvas";
import { useHistory } from "react-router-dom";

// material components
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import SvgIcon from "@material-ui/core/SvgIcon";
import Snackbar from "@material-ui/core/Snackbar";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DeleteIcon from "@material-ui/icons/Delete";
import { ArrowLeft, CloudUpload } from "@material-ui/icons";

// styles
import useSignStyles from "../styles/signStyles";
import useStyles from "../styles/index";

// context
import { useAuthDispatch } from "../contexts/AuthContext";

// api
import { Container, Typography } from "@material-ui/core";

// layout
import AuthLayout from "../components/AuthLayout";
import { sanaBaseUrl } from '../constants';

const Signature = () => {
  // uses
  const dispatch = useAuthDispatch();
  const history = useHistory();
  // style
  const [width, setWidth] = useState(100);
  const inputsContainer = useRef<null | HTMLDivElement>(null);
  const classes = useStyles();
  const signClasses = useSignStyles();
  // page vars
  const [image, setImage] = useState<File | null>(null);  
  const [officeCode, setOfficeCode] = useState('');
  const imageRef = useRef(null);
  const inputRef = useRef(null);
  const signatureRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(true);
  const [showSnack, setShowSnack] = useState(false);
  const [tab, setTab] = React.useState(0);

  // effects

  useEffect(() => {
    const containerHeight = inputsContainer.current!.clientHeight;
    setWidth(containerHeight);

    let timerRemiander = setTimeout(() => {
      window.location.href = sanaBaseUrl;

    }, 600000);

    return () => {

      clearTimeout(timerRemiander)
    };
  }, []);

  // methods

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const onImageUpload = () => {
    if (inputRef.current && imageRef.current) {
      const file = (inputRef.current! as HTMLInputElement).files?.item(0);
      setImage(file || null);
      if (file?.type.includes("image")) {
        const image = imageRef.current! as HTMLImageElement;
        const reader = new FileReader();
        reader.onload = function (e) {
          image.src = e?.target?.result as string;
        };
        reader.readAsDataURL(file);
      }
    }
  };
  const next = async () => {
    if (
      signatureRef.current &&
      (signatureRef.current as any).isEmpty() &&
      !image
    ) {
      setShowSnack(true);
      return;
    }
    if (!signatureRef.current || (signatureRef.current as any).isEmpty()) {
      const toBase64 = (file: File): Promise<string> =>
        new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result as string);
          reader.onerror = (error) => reject(error);
        });
      const b64 = await toBase64(image as File);
      dispatch({
        type: "SET_SIGN",
        signature: b64,
        officeCode: officeCode,
      });
    } else {
      dispatch({
        type: "SET_SIGN",
        signature: (signatureRef.current as any).getTrimmedCanvas().toDataURL('image/png'),
        officeCode: officeCode,
      });
    }
    history.replace("/selfieImage");
    // alert(officeCode);
  };

  const clear = () => {
    setImage(null);
    if (signatureRef.current) {
      (signatureRef.current as any).clear();
    }
  };

  return (
    < >
      <div className={classes.root}>
        {/* <AppBar position="static">
          <Tabs
            value={tab}
            onChange={handleChangeTab}
            aria-label="simple tabs example"
          >
            <Tab label="رسم امضا" />
            <Tab label="بارگذاری امضا" />
          </Tabs>
        </AppBar> */}
        <Container className={classes.content}>
          <div
            ref={inputsContainer}
            className={classes.inputsContainer}
            style={{ width: `${width}px` }}
          >
            {tab === 0 ? (
              <div className={classes.inputContainer}>
                <SignatureCanvas
                  ref={signatureRef}
                  backgroundColor={`rgb(255, 255, 255)`}
                  canvasProps={{
                    width: width,
                    height: width,
                    className: signClasses.canvas,
                  }}
                />
              </div>
            ) : (
              <div className={classes.inputContainer}>
                <input
                  ref={inputRef}
                  className={signClasses.fileInput}
                  type="file"
                  accept="image/*"
                  onChange={onImageUpload}
                />
                <img
                  ref={imageRef}
                  alt="sing"
                  className={clsx([
                    signClasses.image,
                    image && signClasses.showImage,
                  ])}
                />
                <CloudUpload className={signClasses.uploadIcon} />
              </div>
            )}
          </div>
          <Typography align="center" variant="caption" style={{ paddingTop: '4px' }}>
            کلیه حقوق سامانه احراز هویت دیجیتال ویدا متعلق به شرکت کیاهوشان است.
          </Typography>

          <br/>         
         <label>
            کد معرف:
            &nbsp; <input type="text" value={officeCode} placeholder="اختیاری" onChange={(e) => setOfficeCode(e.target.value)}/>
          </label>


          <div className={classes.actionBar}>
            <Button
              variant="outlined"
              color="primary"
              className="last"
              startIcon={<DeleteIcon />}
              onClick={clear}
            >
              حذف
            </Button>
            <Button
              variant="outlined"
              color="primary"
              endIcon={<ArrowLeft />}
              onClick={next}
            >
              مرحله بعد
            </Button>
          </div>
        </Container>
      </div>
      <Dialog open={openDialog}>
        <DialogTitle id="simple-dialog-title">دریافت امضا</DialogTitle>
        <DialogContent>
          <SvgIcon color="primary" fontSize="large">
            <path d="M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z" />
          </SvgIcon>
          <ul>
            <li>
              <DialogContentText className={classes.justifyText}>
                در این مرحله شما باید امضا خود را در کادر سفید رسم کنید .
              </DialogContentText>
            </li>
            <li>
              <DialogContentText className={classes.justifyText}>
                برای رسم امضا خود در تلفن همراه با لمس کردن بر روی صفحه گوشی
                هوشمند و در رایانه به وسیله موس اقدام نمایید.
              </DialogContentText>
            </li>
          </ul>
          <img
            className={signClasses.signExample}
            src="./sign-example.png"
            alt="example-sign"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            ادامه
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={showSnack}
        autoHideDuration={2000}
        message="لطفا امضا خود را رسم کنید."
        onClose={() => setShowSnack(false)}
      />
    </>
  );
};

export default Signature;
